module.exports = __webpack_public_path__ + "static/media/FAQ.1bbb78d4.png";